import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { file, integerRangeValidator, plainText, requiredNumberValidator } from '../../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../../modules/formatters';
import {
    HUB_CUSTOM_HTML_IFRAME_HEIGHT_DEFAULT,
    HUB_CUSTOM_HTML_IFRAME_HEIGHT_MAX,
    HUB_CUSTOM_HTML_IFRAME_HEIGHT_MIN,
} from '../../../../../../../../constants/common.constants';

export const ENABLED = 'enabled';
export const LABEL = 'label';
export const ZIP_FILE = 'zipFile';
export const OBJECT_KEY = 'objectKey';
export const IFRAME_HEIGHT = 'iframeHeight';
export const POSITION_ORDER = 'positionOrder';

const FORM_CONFIG = {
    [ENABLED]: {
        defaultValue: true,
    },
    [LABEL]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [ZIP_FILE]: {
        defaultValue: null,
        validators: [file.requiredField, file.fileType.zip, file.maxSize.zip],
    },
    [OBJECT_KEY]: {
        defaultValue: '',
    },
    [IFRAME_HEIGHT]: {
        defaultValue: HUB_CUSTOM_HTML_IFRAME_HEIGHT_DEFAULT,
        validators: [requiredNumberValidator, integerRangeValidator(HUB_CUSTOM_HTML_IFRAME_HEIGHT_MIN, HUB_CUSTOM_HTML_IFRAME_HEIGHT_MAX)],
    },
    [POSITION_ORDER]: {
        defaultValue: 0,
    },
};

export const CUSTOM_HTML_MODULE_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
